module.exports = __webpack_public_path__ + "img/icon-users.22e09537.svg";